import { render, staticRenderFns } from "./_purgeSBOTeam.vue?vue&type=template&id=60bb7090&scoped=true&lang=pug&"
import script from "./_purgeSBOTeam.vue?vue&type=script&lang=js&"
export * from "./_purgeSBOTeam.vue?vue&type=script&lang=js&"
import style0 from "./_purgeSBOTeam.vue?vue&type=style&index=0&id=60bb7090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bb7090",
  null
  
)

export default component.exports